module.exports = __webpack_public_path__ + "static/media/team-3.497bb359.jpg";